// src/stone/illustrations/CoinStackIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CoinStackIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 4 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M36.293 22.459a10.4 10.4 0 0 1-.318 2.559 10 10 0 0 1-.507 1.5 9.713 9.713 0 0 1-.673 1.323 10.44 10.44 0 0 1-8.955 5.074l-3.785-.001-.038-11.95-.029-7.794.946-.001 7.157-.277q.226.102.45.214.387.192.75.418-3.633.175-7.268.353c-.3.014-.294.481.007.468l7.914-.388.08.059a10.43 10.43 0 0 1 4.065 6.352c.133.674.205 1.374.204 2.091"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M31.841 26.132c-2.04 5.403-8.067 8.137-13.464 6.108a10.37 10.37 0 0 1-5.801-5.404l2.49-1.887a7.4 7.4 0 0 1-.302-1.125l-2.599 1.97a10 10 0 0 1-.198-.662l.034-.02 2.6-1.971.035-.584-.304.228-2.479 1.877a10.435 10.435 0 0 1 .427-5.83q.009-.025.019-.05a10.48 10.48 0 0 1 9.688-6.777L25.819 12h.05a10.5 10.5 0 0 1 3.65.658q.29.11.572.234l-3.496.135q.623.299 1.188.667l3.508-.17q.005.001.009.004.333.201.644.43l-3.541.172a10.4 10.4 0 0 1 2.828 3.287 10.42 10.42 0 0 1 .61 8.714"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m17.273 27.328.001.001.016.017 10.778-8.16-.013-.024zm0 0a6.8 6.8 0 0 1-1.588-2.441m1.588 2.441-1.588-2.441m0 0a7 7 0 0 1-.173-.52l10.179-7.707q.232.144.451.306a6.8 6.8 0 0 1 1.913 2.196zM12.767 25.998l-.01-.025 1.699-1.287.024.08-1.694 1.284z"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "coin-stack_Illustration_svg__a", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "m12.165 25.795.006.018z" }) }),
      /* @__PURE__ */ jsx("path", { fill: "#FCFCFC", d: "m12.165 25.795.006.018z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m12.165 25.795.962-.275-.208-.725h-.754zm.006.018-.92.394 1.881-.668zm-.007-.018v-1h-1.326l.365 1.275zm-.96.275.008.027-.003-.01 1.923-.548-.005-.02-.004-.009q0-.001 0 0l.004.01zm1.886-.65a1 1 0 0 1 .036.1l-1.923.55q.014.053.048.137zm-.926 1.375zv-2z",
          mask: "url(#coin-stack_Illustration_svg__a)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M21.618 27.34c-.391 0-.795-.07-1.194-.213-1.48-.532-2.26-2.093-2.16-3.295a.135.135 0 1 1 .268.022c-.093 1.102.624 2.532 1.983 3.02.98.352 1.99.229 2.705-.327.54-.42.813-1.034.75-1.684-.119-1.225-.874-1.763-1.83-2.443l-.088-.062c-.977-.696-1.79-1.36-1.827-2.437a2.09 2.09 0 0 1 .878-1.78c.69-.504 1.647-.607 2.56-.28 1.09.391 1.682 1.358 1.873 2.132a.135.135 0 1 1-.262.065c-.175-.706-.714-1.588-1.703-1.943-.841-.302-1.684-.213-2.31.243a1.83 1.83 0 0 0-.768 1.554c.033.956.763 1.55 1.714 2.228l.087.061c.973.692 1.812 1.289 1.943 2.637.072.743-.239 1.444-.853 1.922-.492.382-1.11.58-1.766.58"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M20.036 28.164a.135.135 0 0 1-.127-.18l3.967-11.093a.135.135 0 0 1 .253.09l-3.967 11.094a.13.13 0 0 1-.126.089"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "coin-stack_Illustration_svg__b", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "m14.635 22.558-.035.583-2.6 1.97a.2.2 0 0 1-.035.021 8 8 0 0 1-.113-.47l2.479-1.877z" }) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m14.635 22.558-.035.583-2.6 1.97a.2.2 0 0 1-.035.021 8 8 0 0 1-.113-.47l2.479-1.877z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m14.635 22.558.998.06.129-2.15-1.726 1.288zm-.035.583.604.797.366-.278.028-.459zm-2.6 1.97.6.8.004-.002zm-.035.021-.965.263.302 1.11 1.057-.453zm-.113-.47-.604-.797-.505.383.13.62zm2.479-1.877-.603-.798-.001.001zm-.695-.287-.035.583 1.997.12.035-.584zm.36-.154-2.6 1.97 1.207 1.595 2.6-1.97zm-2.597 1.968a1 1 0 0 1 .173-.099l.787 1.838c.12-.05.203-.111.24-.14zm1.531.558a7 7 0 0 1-.1-.413l-1.957.411q.057.27.127.527zm-.475.59 2.48-1.878-1.208-1.594-2.48 1.877zm2.478-1.876.29-.218.007-.005.002-.002-.598-.801-.598-.802-.002.002-.007.005-.025.019-.274.205z",
          mask: "url(#coin-stack_Illustration_svg__b)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M16.939 27.973a.14.14 0 0 1-.093-.037 7.6 7.6 0 0 1-1.907-2.942 7.52 7.52 0 0 1 .052-5.199 7.5 7.5 0 0 1 1.316-2.232.134.134 0 0 1 .189-.015.134.134 0 0 1 .015.189 7.3 7.3 0 0 0-1.508 2.913 7.25 7.25 0 0 0 .19 4.253 7.3 7.3 0 0 0 1.839 2.837.135.135 0 0 1 .004.19.13.13 0 0 1-.097.043"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M43.291 26.428V52H13.53v-6.498H11.5v-6.227h2.033v-6.36h19.134v-6.487z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "M45.857 51.5V26.928h1.913V51.5zM43.791 51.5V26.928h.07V51.5z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M50.465 32.654v6.623H52.5v6.227h-2.034V52H48.27V26.428h4.23v6.226zM45.357 26.428h-.996V52h.996z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#1D232A", d: "M32.667 39.013H31.65v6.663h1.017z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M28.063 52h3.589V32.915h-.964l-.812 5.899-.096.696-.811 5.897-.096.696z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M50.466 39.007v.269H13.532l-.009-.001h.01v-.268zM50.467 32.647H32.668v.268h17.799zM50.465 45.503H13.53v.269h36.936z"
        }
      )
    ]
  }
);
var CoinStackIllustration_default = CoinStackIllustration;

export {
  CoinStackIllustration,
  CoinStackIllustration_default
};
